export default {
  searchHoverLevel: 10000,
};
